export const DATE_FORMAT = `DD.MM.YYYY`;
export const PICKER_DATE_FORMAT = `dd.MM.yyyy`;
export const API_DATE_FORMAT = `YYYY-MM-DD`;
export const TIME_FORMAT = `HH:mm:ss`;
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;